import config from "@/services/Api-config";

export default {
  // apps quickmenu
  apps: [{
    icon: "mdi-email-outline",
    text: "Profile",
    key: "menu.profile",
    subtitle: "Hey!",
    link: () => { window.location.href = config.SENTEC_ACCOUNTS_URL + "/my-account/profile"; }
  }],

  // user dropdown menu
  user: [
    {
      icon: "mdi-account-box-outline",
      key: "menu.profile",
      text: "Profile",
      link: () => { window.location.href = config.SENTEC_ACCOUNTS_URL + "/my-account/profile"; }
    }
  ]
};
